// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"965f40ae2fbf836341af","303":"5e5cc7d27cdb3fc5f235","495":"4e396eb2fc91988a7876"}[chunkId] + ".js";
};